module.exports = __webpack_public_path__ + "img/katarina_kitchen_12.1d45d2e5.jpg";